import MainRoutes from "./main";

const routes = {
  MainRoutes,
};

export default routes;